import { isCmoePrimaryOrchestration } from "../../../config/cmoeOrchestrationMode";

/**
 * V1 compatibility mirrors (roomMatches + liveMatches) run only in primary mode.
 * Set orchestration mode to legacy/dual to disable mirrors without schema changes.
 */
export function isCmoeV1CompatibilityMirrorEnabled() {
  return isCmoePrimaryOrchestration();
}
